import {
  ColorPicker as MantineColorPicker,
  ColorPickerProps,
} from '@mantine/core';
import {AdapterProps, FieldAdapter} from '../field-factory';
import {FC} from 'react';

export type $ColorPickerAdapterProps = AdapterProps<ColorPickerProps>;

export const $ColorPickerAdapter: FC<FieldAdapter<$ColorPickerAdapterProps>> = (
  props
) => {
  const {
    inputProps: {onChange, ...inputProps},
    control,
  } = props;

  const {
    field: {onChange: fieldOnChange, ...fieldProps},
  } = control;

  const _onChange: ColorPickerProps['onChange'] = (e) => {
    fieldOnChange(e);
    onChange?.(e);
  };

  return (
    <MantineColorPicker onChange={_onChange} {...fieldProps} {...inputProps} />
  );
};